/* MotionAuto launch reveal (PBG #31 launch theme, Oct 12 2026).
   Add-on for the v2 homepage: the first time a visitor lands while the giveaway is live, the
   engine is off (needle at 0, LEDs dark) and the dial shows a dim, pulsing 300X (the copy around it
   says 300X too). When they tap the gauge (or the engine button) the homepage's own engine rev plays
   as always (original throttle track + sound), a counter climbs on the dial and a bright "300X" slams
   on and stays.
   - Only runs for the multipliers listed in window.MA_REVEAL.mults (set in sections/ma-home-v2.liquid).
   - Once per visitor per multiplier (localStorage ma_reveal_<mult>). ?reveal=1 forces it, ?reveal=0 skips it.
   - Also swaps the cash-drop chip prices listed in MA_REVEAL.prices (new VIP pricing), puts the PBG #31
     landing image (MA_REVEAL.slide: desktop + mobile art) in place of the old S14 carousel slide, and
     tints the red streaks of the tunnel canvas behind the gauge to the launch green.
   - Gives each key tag on the winners' key board a static shadow (.ma-tsh) so the scroll swing stays smooth.
   - Live state (Oct 13): while the current multiplier is the top of MA_REVEAL.ladder the hero says it is the best
     multiplier of the build and when it drops; "Watch the builds" becomes "Watch Episode 1" (opens MA_REVEAL.ep1 once
     set, otherwise jumps to the player); the build-log player (#hp-watch) moves up right under the tach and
     opens on the #31 (Classified / Episode 1) tab instead of the last build.
   - Skipped under prefers-reduced-motion. Never edits the hosted homepage script; it only parks the
     needle/LEDs at 0 until the tap.
   - After the reveal (and for returning visitors) the multiplier stays stamped on the dial while it
     is still the current one. */
(function () {
  var root = document.documentElement;
  var CFG = window.MA_REVEAL || { mults: ['300'] };
  var qs = location.search;
  var FORCE = /[?&]reveal=1\b/.test(qs), SKIP = /[?&]reveal=0\b/.test(qs);
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion:reduce)').matches;
  var NS = 'http://www.w3.org/2000/svg', CX = 200, CY = 190;

  function unpend() { root.classList.remove('ma-rv-pend'); }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
  function $(id) { return document.getElementById(id); }

  /* ---- new VIP prices on the cash-drop chips (the homepage script builds them) ---- */
  var PRICES = (window.MA_REVEAL && window.MA_REVEAL.prices) || {};
  function chips() {
    var s = document.querySelectorAll('#hq-cash a span');
    for (var i = 0; i < s.length; i++) {
      var b = s[i].querySelector('b'), n = b && b.nextSibling, p = b && PRICES[b.textContent.trim()];
      if (p && n && n.nodeType === 3 && n.nodeValue.trim() === p[0]) n.nodeValue = p[1];
    }
    return s.length;
  }
  var ctries = 0;
  function chipBoot() {
    if (!chips()) { if (++ctries < 150) setTimeout(chipBoot, 100); return; }
    var cash = $('hq-cash');
    if (cash && window.MutationObserver) { var co = new MutationObserver(function () { co.disconnect(); chips(); co.observe(cash, { childList: true, subtree: true, characterData: true }); }); co.observe(cash, { childList: true, subtree: true, characterData: true }); }
  }

  /* ---- the multiplier stamped on the dial face, under the needle; removed if the phase changes ---- */
  function makeStamp(g, ndl, text, cls) {
    var st = document.createElementNS(NS, 'text'), SA = Element.prototype.setAttribute;
    SA.call(st, 'x', CX); SA.call(st, 'y', 172); SA.call(st, 'text-anchor', 'middle'); SA.call(st, 'class', cls);
    st.textContent = text;
    g.insertBefore(st, ndl);
    return st;
  }
  function guard(st, ml, mult) {
    if (!window.MutationObserver) return;
    var ok = new RegExp('^' + mult + 'X\\b');
    var o = new MutationObserver(function () {
      var t = (ml.textContent || '').trim();
      if (t.indexOf('???') < 0 && !ok.test(t)) { o.disconnect(); if (st.parentNode) st.parentNode.removeChild(st); }
    });
    o.observe(ml, { childList: true, characterData: true, subtree: true });
  }

  /* ---- PBG #31 landing image replaces the S14 thank-you slide (the homepage script builds the carousel) ---- */
  var SL = window.MA_REVEAL && window.MA_REVEAL.slide, FILES = 'https://cdn.shopify.com/s/files/1/2132/0831/files/';
  function swapSlide() {
    var track = $('hq-track'), car = $('hq-car'); if (!track || !car || !SL) return false;
    var a = track.querySelectorAll('a.hq-slide');
    for (var i = 0; i < a.length; i++) {
      var fg = a[i].querySelector('img.fg');
      if (!fg || a[i].getAttribute('data-ma') || (fg.getAttribute('src') || '').indexOf(SL.replace) < 0) continue;
      a[i].setAttribute('data-ma', '1');
      if (SL.href) a[i].href = SL.href;
      a[i].setAttribute('aria-label', SL.alt);
      var D = FILES + SL.desktop, M = FILES + SL.mobile;
      var pic = document.createElement('picture'), so = document.createElement('source'), im = document.createElement('img');
      so.media = '(max-width:700px)'; so.srcset = M + '?width=700 700w,' + M + '?width=1000 1000w,' + M + '?width=1254 1254w'; so.sizes = '100vw';
      im.className = 'fg'; im.alt = SL.alt; im.draggable = false; im.src = D + '?width=1600';
      im.srcset = D + '?width=1000 1000w,' + D + '?width=1440 1440w,' + D + '?width=1920 1920w'; im.sizes = '100vw';
      pic.appendChild(so); pic.appendChild(im); fg.parentNode.replaceChild(pic, fg);
      var bg = a[i].querySelector('img.bg'); if (bg) bg.src = D + '?width=400';
      car.classList.add('ma-pbg31');
    }
    return true;
  }
  function slideBoot(n) {
    if (!swapSlide()) { if ((n || 0) < 150) setTimeout(function () { slideBoot((n || 0) + 1); }, 100); return; }
    if (window.MutationObserver) new MutationObserver(swapSlide).observe($('hq-track'), { childList: true });
  }
  /* ---- tunnel canvas behind the gauge: red streaks drawn by the homepage script -> launch green ---- */
  function tintTunnel() {
    var c = $('hp-tun'); if (!c || !c.getContext) return;
    try {
      var ctx = c.getContext('2d'), d = Object.getOwnPropertyDescriptor(CanvasRenderingContext2D.prototype, 'strokeStyle');
      if (!ctx || !d || Object.prototype.hasOwnProperty.call(ctx, 'strokeStyle')) return;
      Object.defineProperty(ctx, 'strokeStyle', { configurable: true, get: function () { return d.get.call(this); },
        set: function (v) { if (typeof v === 'string') v = v.replace('rgba(255,59,46,', 'rgba(61,220,132,'); d.set.call(this, v); } });
    } catch (e) {}
  }

  /* ---- key board: static tag shadows instead of a blurred filter on every swinging key (CSS in sections/ma-home-v2.liquid) ---- */
  function keyShadows() {
    var bd = document.querySelector('#hp .hq-board'); if (!bd) return null;
    var k = bd.querySelectorAll('.hq-key');
    for (var i = 0; i < k.length; i++) {
      var has = false, c = k[i].children;
      for (var j = 0; j < c.length; j++) if ((' ' + c[j].className + ' ').indexOf(' ma-tsh ') > -1) { has = true; break; }
      if (!has) { var s = document.createElement('i'); s.className = 'ma-tsh'; s.setAttribute('aria-hidden', 'true'); k[i].appendChild(s); }
    }
    if (k.length) bd.classList.add('ma-sh');
    return k.length ? bd : null;
  }
  function keyBoot(n) {
    var bd = keyShadows();
    if (!bd) { if ((n || 0) < 150) setTimeout(function () { keyBoot((n || 0) + 1); }, 100); return; }
    if (window.MutationObserver) new MutationObserver(keyShadows).observe(bd, { childList: true });
  }

  var tries = 0;
  function boot() {
    var g = $('hp-gauge'), ml = $('hp-multl'), eye = $('hp-eye');
    var ndl = g && g.querySelector('path.ndl');
    var leds = document.querySelectorAll('#hp-leds i');
    /* wait for the homepage script to build the gauge and paint the copy */
    if (!(g && ml && eye && ndl && leds.length && (eye.textContent || '').trim())) {
      if (++tries < 120) return setTimeout(boot, 100);
      return unpend();
    }
    var m = /^(\d+)X/.exec((ml.textContent || '').trim());
    if (!m || !/live now/i.test(eye.textContent) || CFG.mults.indexOf(m[1]) < 0) return unpend();
    if (SKIP || RM || (!FORCE && store('ma_reveal_' + m[1]))) { unpend(); guard(makeStamp(g, ndl, m[1] + 'X', 'ma-rv-stamp is-on'), ml, m[1]); return; }
    try { reveal(g, ndl, leds, ml, m[1]); } catch (e) { unpend(); }
  }

  function reveal(g, ndl, leds, ml, mult) {
    /* Engine off until the tap: the needle rests at 0 and the LEDs are dark (the homepage's own loop
       keeps running, its needle/LED writes are just parked). On the tap the needle eases onto the
       homepage's reading in 0.35 s and from then on it is 100% the original throttle track + sound.
       The dial number: a dim pulsing 300X until the tap, then a counter that climbs while the engine
       revs and a bright 300X slam that stays. */
    var cluster = g.parentNode, SA = Element.prototype.setAttribute, TG = DOMTokenList.prototype.toggle, N = +mult;
    var liveT = ndl.getAttribute('transform') || 'rotate(0 ' + CX + ' ' + CY + ')', ledLive = [], parked = true;
    ndl.setAttribute = function (n, v) { if (n === 'transform') { liveT = v; return; } return SA.call(this, n, v); };
    for (var i = 0; i < leds.length; i++) (function (j) { ledLive[j] = leds[j].classList.contains('on'); leds[j].classList.toggle = function (n, f) { if (n === 'on') ledLive[j] = f === undefined ? !ledLive[j] : !!f; return false; }; })(i);
    function deg(a) { SA.call(ndl, 'transform', 'rotate(' + a.toFixed(2) + ' ' + CX + ' ' + CY + ')'); }
    function liveDeg() { var m = /rotate\(\s*(-?[\d.]+)/.exec(liveT); return m ? parseFloat(m[1]) : -120; }
    deg(-120);
    for (var k = 0; k < leds.length; k++) TG.call(leds[k].classList, 'on', false);
    function unpark() {
      if (!parked) return; parked = false;
      try { delete ndl.setAttribute; } catch (e) {}
      for (var i = 0; i < leds.length; i++) { try { delete leds[i].classList.toggle; } catch (e) {} TG.call(leds[i].classList, 'on', !!ledLive[i]); }
      SA.call(ndl, 'transform', liveT);
    }
    function release() {
      var t1 = performance.now(), D = 350;
      (function step(now) {
        if (!parked) return;
        var k = Math.min(1, Math.max(0, (now - t1) / D)), e = 1 - Math.pow(1 - k, 3);
        deg(-120 + (liveDeg() + 120) * e);
        if (k < 1) requestAnimationFrame(step); else unpark();
      })(t1);
      setTimeout(unpark, 1500); /* safety net */
    }
    var st = makeStamp(g, ndl, mult + 'X', 'ma-rv-stamp is-wait');
    root.classList.add('ma-rv-on');
    unpend();

    var T_COUNT = 2.2, T_SLAM = 2.7, t0 = 0, done = false, lastFlick = 0, shown = '';
    function show(txt) { if (txt !== shown) { shown = txt; st.textContent = txt; } }
    function frame(now) {
      if (done) return;
      var t = (now - t0) / 1000;
      if (t < T_COUNT) { var p = Math.max(0, t) / T_COUNT; show(Math.floor(N * .96 * (1 - Math.pow(1 - p, 2.2))) + 'X'); }
      else if (t < T_SLAM) { if (now - lastFlick > 60) { lastFlick = now; show(Math.floor(N * (.83 + Math.random() * .16)) + 'X'); } }
      else return finish();
      requestAnimationFrame(frame);
    }
    function finish() {
      if (done) return; done = true;
      show(mult + 'X');
      SA.call(st, 'class', 'ma-rv-stamp is-slam');
      cluster.classList.add('ma-rv-shake');
      ml.classList.add('ma-rv-pop');
      store('ma_reveal_' + mult, String(Date.now()));
      root.classList.remove('ma-rv-on');
      guard(st, ml, mult);
      setTimeout(function () { cluster.classList.remove('ma-rv-shake'); SA.call(st, 'class', 'ma-rv-stamp is-on'); }, 600);
      setTimeout(function () { ml.classList.remove('ma-rv-pop'); }, 900);
    }
    function go() { if (t0) return; release(); SA.call(st, 'class', 'ma-rv-stamp'); show('0X'); t0 = performance.now(); setTimeout(finish, 6000); /* safety net */ requestAnimationFrame(frame); }
    /* the reveal starts on the visitor's tap: the gauge itself or the engine start button
       (the homepage's own click handler runs as usual: engine sound + throttle track on the needle) */
    var btn = $('hp-revl');
    function onTap() { g.removeEventListener('click', onTap, true); if (btn) btn.removeEventListener('click', onTap, true); go(); }
    g.addEventListener('click', onTap, true);
    if (btn) btn.addEventListener('click', onTap, true);
  }

  /* ---- live state: best-multiplier copy, Episode 1 button, player under the tach ---- */
  var MO = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  function nice(d) { var a = d.split('-'); return MO[+a[1] - 1] + ' ' + (+a[2]); }
  function today() {
    var f = /[?&]hpdate=(\d{4}-\d\d-\d\d)/.exec(qs); if (f) return f[1];
    try { return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Denver' }); } catch (e) { return new Date().toISOString().slice(0, 10); }
  }
  function txt(id) { var e = $(id); return e ? (e.textContent || '').trim() : ''; }
  var liveBusy = false;
  function livePatch() {
    if (liveBusy) return true;
    var eye = $('hp-eye'), sub = $('hp-sub'), odol = $('hp-odol'), cta = $('hp-cta');
    if (!eye || !odol || !cta || !txt('hp-eye')) return false;
    if (!/live now/i.test(txt('hp-eye'))) return true; /* not live (doors not open yet): leave the hosted copy alone */
    liveBusy = true;
    try {
      var L = CFG.ladder || [], m = /^(\d+)X/.exec(txt('hp-multl')), cur = m ? +m[1] : 0, d = today(), top = 0, i, at = -1;
      for (i = 0; i < L.length; i++) { if (L[i][0] > top) top = L[i][0]; if (at < 0 && L[i][0] === cur && d <= L[i][2]) at = i; }
      var best = cur && cur === top, nx = at > -1 ? L[at + 1] : null;
      if (best) {
        if (!eye.querySelector('.ma-best-eye')) { var sp = document.createElement('span'); sp.className = 'ma-best-eye'; sp.textContent = ' · Best multiplier of the build'; eye.appendChild(sp); }
        /* Oct 14: never name the next multiplier or its date (Aaron); the countdown alone says when this rate ends */
        var line = 'Every $1 is ' + cur + ' entries right now, the most this Supra will ever get.';
        if (sub && sub.textContent !== line) { sub.textContent = line; sub.hidden = false; }
        if (!odol.querySelector('.ma-best')) {
          odol.innerHTML = '';
          var b = document.createElement('b'); b.textContent = cur + 'X'; odol.appendChild(b);
          odol.appendChild(document.createTextNode(' · '));
          var hi = document.createElement('span'); hi.className = 'ma-best'; hi.textContent = 'best rate'; odol.appendChild(hi);
          odol.appendChild(document.createTextNode(' ends in'));
        }
      }
      var w = cta.querySelector('a[href="#hp-watch"]') || cta.querySelector('a[data-ma-ep]');
      if (w && !w.getAttribute('data-ma-ep')) {
        var a = w;
        if (CFG.ep1) { a = w.cloneNode(false); a.href = CFG.ep1; a.target = '_blank'; a.rel = 'noopener'; w.parentNode.replaceChild(a, w); }
        /* Oct 14: until the episode's link is in MA_REVEAL.ep1 the button says it is coming (Aaron); it still jumps to the player */
        a.textContent = CFG.ep1 ? 'Watch Episode 1' : 'Episode 1 drops soon'; a.setAttribute('data-ma-ep', '1');
      }
    } catch (e) {}
    liveBusy = false;
    return true;
  }
  var tabDone = false, tabTries = 0;
  function moveWatch() {
    var hero = $('hp-hero'), w = $('hp-watch');
    if (!hero || !w) return false;
    /* the "New drop" merch row (#ma-nd) may sit between the tach and the player: keep it there */
    var after = hero.nextElementSibling && hero.nextElementSibling.id === 'ma-nd' ? hero.nextElementSibling : hero;
    if (after.nextElementSibling !== w) hero.parentNode.insertBefore(w, after.nextSibling);
    if (!tabDone) { /* open the player on the #31 tab once (the visitor's own clicks are left alone) */
      var t = w.querySelector('button.hq-pre.lock');
      if (!t && ++tabTries < 100) return false;
      tabDone = true;
      if (t && (' ' + t.className + ' ').indexOf(' on ') < 0) { var y = window.pageYOffset; t.click(); if (window.pageYOffset !== y) window.scrollTo(0, y); }
    }
    return true;
  }
  function liveBoot(n) {
    var ok = livePatch(), mv = moveWatch();
    if (!(ok && mv)) { if ((n || 0) < 150) setTimeout(function () { liveBoot((n || 0) + 1); }, 100); return; }
    if (!window.MutationObserver) return;
    var o = new MutationObserver(function () { if (!liveBusy) { o.disconnect(); livePatch(); watchIt(); } });
    function watchIt() { ['hp-eye', 'hp-sub', 'hp-odol', 'hp-cta'].forEach(function (id) { var e = $(id); if (e) o.observe(e, { childList: true, characterData: true, subtree: true }); }); }
    watchIt();
  }

  function start() { tintTunnel(); boot(); chipBoot(); slideBoot(0); keyBoot(0); liveBoot(0); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
